<script>
  import FieldStateProvider from './FieldStateProvider.svelte';

  import * as uuid from 'uuid';

  export let error = false;
  export let warning = false;

  export let required = false;
  export let testid = undefined;
  
  export let newBrand = false;

  const id = uuid.v4();
  const label = (element) => {
    element.setAttribute('id', id);
  };
</script>

<div class='field' data-cy={testid}>
  <label class='field-label' class:new-brand={newBrand} for={id} class:error class:warning>
    <slot name='label' />
    {#if required}
      <span class='required'>*</span>
    {/if}
  </label>
  <div class='field-input'>
    <FieldStateProvider {error} {warning} {label}>
      <slot {label} />
    </FieldStateProvider>
  </div>
  <span class:field-hint={$$slots.hint} class:error class:warning>
    <slot name='hint' />
  </span>
</div>

<style lang="postcss">
  .field {
    max-width: 100%;
    display: inline-flex;
    flex-direction: column;
    flex-basis: var(--Field--flex-basis);
    flex-grow: 1;
  }

  .field-input {
    display: flex;
    min-width: 0;

    & > :global(*) {
      /* This is kind of cheating... but we always expect field contents to be the
       * width of the field */
      flex-grow: 1;
    }
  }

  .field-label {
    display: flex;
    align-items: center;
    gap: var(--spacing--xxs);
    font: var(--font--outfit-title-12);
    margin-bottom: 4px;
    transition: color var(--duration--fast) var(--ease--on-screen);


    &.new-brand {
      font: var(--font--body-outfit-label);
      color: var(--color--core-white);
      text-transform: uppercase;
      margin-bottom: 12px; 
    }
  }

  .field-hint {
    margin-top: 4px;
    margin-left: 12px;
    font: var(--font--outfit-12);
    transition: color var(--duration--fast) var(--ease--on-screen);
  }

  .error {
    color: var(--color--error);
  }

  .warning {
    color: var(--color--warning);
  }

  .required {
    color: var(--color--red);
  }
</style>
